import React from 'react';

import Icons from './Icons';

const StepSupport = () => {
  return (
    <div className="bg">
      <div className="container">
        <div className="step fourth">
          <div className="left-section">
            <div className="number-border">
              <div className="number-step">
                <span>4</span>
              </div>
            </div>
          </div>
          <div className="right-section">
            <h3 className="tt">Support and maintenance</h3>
            <div className="content">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    Once your system is up and running, we care for its stable
                    continuity and reliability! Whenever there is a need for
                    new features, we develop them.
                  </p>
                </div>
              </div>
            </div>
            <Icons
              yourRoleDetails="Enjoy your system, don’t worry about the rest"
              outcomeDetails="Stable and effective software"
              ourRoleDetails="Monitor the stability of the system, fix bugs and respond to customers requests"
              durationDetails="Ongoing"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepSupport;
